import { ContrastActionTypesEnum, ContrastActionTypes} from "./ContrastTypes";
import { ThemeEnum } from "../../../../shared/enums/ThemeEnum/ThemeEnum";

export function changeContrastActions(contrast: ThemeEnum): ContrastActionTypes {
    return {
        type: ContrastActionTypesEnum.CHANGE_CONTRAST,
        contrast
    };
}
